import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Navigation, ArrowRight, Building2 } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PageHero } from "@/components/PageHero";

const SEDI = [
  {
    nome: "Casa della Salute – Genova Centro / Piccapietra",
    tipo: "Attività Ambulatoriale",
    indirizzo: "Largo XII Ottobre 62, 16121 Genova",
    telefono: "010 9641083",
    email: "servizioclienti@cds.it",
    testid: "clinic-card-genova-centro",
  },
  {
    nome: "Casa della Salute – Savona",
    tipo: "Attività Ambulatoriale",
    indirizzo: "Corso Agostino Ricci 203R, 17100 Savona",
    telefono: "010 9641083",
    email: "servizioclienti@cds.it",
    testid: "clinic-card-savona",
  },
  {
    nome: "Casa della Salute – Genova San Benigno / Torri MSC",
    tipo: "Attività Chirurgica",
    indirizzo: "Via Balleydier 5-11, 16149 Genova",
    telefono: "010 9641083",
    email: "servizioclienti@cds.it",
    testid: "clinic-card-genova-san-benigno",
  },
];

export default function Contatti() {
  return (
    <div data-testid="contacts-page">
      <PageHero
        testid="contacts-section"
        eyebrow="Contatti"
        title="Dove ricevo"
        subtitle="Attività ambulatoriale e chirurgica presso le sedi Casa della Salute di Genova e Savona."
      />

      <section className="bg-[#F8FAF8]">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
          <div className="grid gap-6 lg:grid-cols-3">
            {SEDI.map((s, i) => (
              <Reveal key={s.testid} delay={i * 0.07}>
                <div
                  data-testid={s.testid}
                  className="flex h-full flex-col rounded-lg border border-[#D5E2DB] bg-white p-8 shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-[#2E6B50]/50 hover:shadow-md"
                >
                  <div className="flex items-center justify-between gap-3">
                    <div className="flex h-11 w-11 items-center justify-center rounded-full bg-[#E8F1EC] text-[#174C3A]">
                      <Building2 size={19} />
                    </div>
                    <span
                      className={`rounded-full px-5 py-2 text-xs font-bold uppercase tracking-[0.14em] shadow-sm ${
                        s.tipo === "Attività Ambulatoriale"
                          ? "border border-[#174C3A]/25 bg-[#E8F1EC] text-[#174C3A]"
                          : "bg-[#0D3327] text-white"
                      }`}
                    >
                      {s.tipo}
                    </span>
                  </div>
                  <h2 className="mt-6 font-serif text-xl font-semibold leading-snug text-[#0D3327]">{s.nome}</h2>
                  <ul className="mt-5 flex-1 space-y-3.5 text-sm text-[#4B5852]">
                    <li className="flex items-start gap-3">
                      <MapPin size={16} className="mt-0.5 shrink-0 text-[#2E6B50]" />
                      {s.indirizzo}
                    </li>
                    <li className="flex items-center gap-3">
                      <Phone size={16} className="shrink-0 text-[#2E6B50]" />
                      <span>
                        Prenotazioni:{" "}
                        <a
                          href={`tel:+39${s.telefono.replace(/\s/g, "")}`}
                          data-testid={`${s.testid}-phone`}
                          className="font-medium text-[#0D3327] transition-colors duration-300 hover:text-[#2E6B50]"
                        >
                          {s.telefono}
                        </a>
                      </span>
                    </li>
                    <li className="flex items-center gap-3">
                      <Mail size={16} className="shrink-0 text-[#2E6B50]" />
                      <a
                        href={`mailto:${s.email}`}
                        data-testid={`${s.testid}-email`}
                        className="font-medium text-[#0D3327] transition-colors duration-300 hover:text-[#2E6B50]"
                      >
                        {s.email}
                      </a>
                    </li>
                  </ul>
                  <div className="mt-7 flex flex-col gap-3">
                    <a
                      href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(s.indirizzo)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-testid={`${s.testid}-directions`}
                      className="inline-flex items-center justify-center gap-2 rounded-full border border-[#174C3A] px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.12em] text-[#174C3A] transition-colors duration-300 hover:bg-[#174C3A] hover:text-white"
                    >
                      Indicazioni <Navigation size={13} />
                    </a>
                    <Link
                      to="/richiedi-una-valutazione"
                      data-testid={`${s.testid}-evaluation`}
                      className="inline-flex items-center justify-center gap-2 rounded-full bg-[#0D3327] px-5 py-2.5 text-xs font-semibold uppercase tracking-[0.12em] text-white transition-colors duration-300 hover:bg-[#174C3A]"
                    >
                      Richiedi una valutazione <ArrowRight size={13} />
                    </Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
